import React, { useState } from "react";
import { notification } from "antd";
import { apiRequest } from "util/services";
import Representation from './Representation';
import i18n from 'i18next';

const Modal = ({ user, showModal, setShowModal, getSubscribtionStatus }) => {
  const [phoneNumberId, setPhoneNumberId] = useState("");
  const [businessAccountId, setBusinessAccountId] = useState("");
  const [permanentToken, setPermanentToken] = useState("");

  const onSubmit = async () => {
    const payload = {
      firebase_id: user.uid,
      phone_number_id: phoneNumberId,
      whatsapp_business_account_id: businessAccountId,
      whatsapp_permanent_token: permanentToken,
    }
    const result = await apiRequest("users/add_whatsapp_keys", "POST", payload, true);
    if (result && !result.error) {
      notification.success({
        message: i18n.t("notifications.153"),
      });
      getSubscribtionStatus();
    } else {
      notification.error({ message: result.error });
    }
    setShowModal(false);
  }

  return <Representation
    setPhoneNumberId={setPhoneNumberId}
    setBusinessAccountId={setBusinessAccountId}
    setPermanentToken={setPermanentToken}
    onSubmit={onSubmit}
    showModal={showModal}
    setShowModal={setShowModal}
  />
}

export default Modal;
